module.exports = __webpack_public_path__ + "static/media/new-hover.751b2c31.png";


//////////////////
// WEBPACK FOOTER
// ./src/new-hover.png
// module id = 74
// module chunks = 0